var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 46 28",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M39.7 5.9c-3.7-3.7-6-5.9-6-5.9s-2.3 2.3-6 5.9c-1.9 1.9-6.3 6.7-6.3 11.5 0 3.2 2.6 5.8 5.8 5.8 2.1 0 3.9-1.1 4.9-2.8.1-.1.3-.2.5-.2.3 0 .6.2.5.5-.2 1.7-1.2 5.9-5 7.4h11.2c-3.8-1.4-4.8-5.6-5-7.4 0-.3.2-.5.5-.5.2 0 .4.1.5.2 1 1.7 2.8 2.8 4.9 2.8 3.2 0 5.8-2.6 5.8-5.8 0-4.7-4.4-9.5-6.3-11.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    d: "M33.7 5.9l1.6 4.8h5l-4.1 3 1.6 4.8-4.1-3-4.1 3 1.6-4.8-4.1-3h5.1z"
  })));
}
SvgPokerMenu.displayName = 'PokerMenu';
export default SvgPokerMenu;